// @flow

import { sortToText } from '../../../../../utils/strings';

export const sortToObject = (orders: Object, intl: Object) => {
  const obj = {};
  Object.keys(orders).forEach(key => {
    obj[orders[key]] = sortToText(key, intl);
  });
  return obj;
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/sortToObject.js